import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import EnvironmentBanner from './EnvironmentBanner';
import { useAuth } from '../auth/AuthContext';

const NAV_PRIMARY = [
  { to: '/', label: 'Home', end: true, icon: 'home' },
  { to: '/growth', label: 'Growth', end: true, icon: 'growth' },
  { to: '/growth/videos', label: 'Social content', icon: 'videos' },
  { to: '/revenue', label: 'Revenue', icon: 'revenue' },
];

const NAV_SIMULATIONS = [
  { to: '/economics', label: 'Economics', icon: 'economics' },
  { to: '/forecast', label: 'Forecast', icon: 'forecast' },
];

const NAV_REST = [
  { to: '/product', label: 'Product', icon: 'product' },
  { to: '/experiments', label: 'Experiments', icon: 'experiments' },
  { to: '/decisions', label: 'Decisions', icon: 'decisions' },
  { to: '/users', label: 'Users', icon: 'users' },
  { to: '/operations', label: 'Operations', icon: 'operations' },
];

function NavIcon({ name }) {
  const paths = {
    home: 'M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1z',
    growth: 'M4 16l5-5 3 3 8-8M14 6h6v6',
    videos: 'M4 6h11v12H4zM15 10l5-3v10l-5-3z',
    revenue: 'M12 3v18M16 7H9.5a2.5 2.5 0 0 0 0 5h5a2.5 2.5 0 0 1 0 5H7',
    economics: 'M5 19V5M5 19h14M9 15l3-4 2 2 4-5',
    forecast: 'M4 16c2-6 4-6 6 0s4 6 6 0 4-6 4 0',
    product: 'M4 8h16v11H4zM8 8V6a4 4 0 0 1 8 0v2',
    experiments: 'M4 19V5h4v14H4zm6 0V9h4v10h-4zm6 0v-7h4v7h-4z',
    decisions: 'M13 3 4 14h7l-1 7 9-11h-7z',
    users: 'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM16 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM4 19c.5-2.5 2.4-4 5-4s4.5 1.5 5 4M14 15c1.8 0 3.4.9 4 3',
    operations: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM12 3v2M12 19v2M4.2 6.2l1.4 1.4M18.4 16.4l1.4 1.4M3 12h2M19 12h2M4.2 17.8l1.4-1.4M18.4 7.6l1.4-1.4',
    mail: 'M4 6h16v12H4zM4 7l8 6 8-6',
    signout: 'M10 7V5H5v14h5v-2M10 12h9M16 9l3 3-3 3',
  };
  return (
    <svg className="admin-nav-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d={paths[name]} />
    </svg>
  );
}

function NavLinks({ items, sub = false }) {
  return items.map((item) => (
    <NavLink
      key={item.to}
      to={item.to}
      end={item.end}
      className={({ isActive }) => {
        const active = isActive ? 'admin-nav-link admin-nav-link-active' : 'admin-nav-link';
        return sub ? `${active} admin-nav-link-sub` : active;
      }}
    >
      <NavIcon name={item.icon} />
      {item.label}
    </NavLink>
  ));
}

export default function AdminLayout() {
  const { user, logout, isStaff } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="admin-shell">
      <EnvironmentBanner />
      <div className="admin-body">
        <aside className="admin-sidebar" aria-label="Admin navigation">
          <div className="admin-brand">
            <span className="admin-brand-title">FFC Ops</span>
            <span className="admin-brand-env">{process.env.REACT_APP_ENV || 'development'}</span>
          </div>
          <nav className="admin-nav">
            <NavLinks items={NAV_PRIMARY} />
            <p className="admin-nav-section">Simulations</p>
            <NavLinks items={NAV_SIMULATIONS} sub />
            <NavLinks items={NAV_REST} />
          </nav>
          <div className="admin-sidebar-footer">
            {isStaff && <p className="admin-readonly-badge">Read-only (STAFF)</p>}
            <p className="admin-user-email">
              <NavIcon name="mail" />
              <span>{user?.email}</span>
            </p>
            <button type="button" className="secondary-button admin-signout" onClick={handleLogout}>
              <NavIcon name="signout" />
              Sign out
            </button>
          </div>
        </aside>
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
